import { createAsyncThunk } from '@reduxjs/toolkit';
import { AppDispatch } from '@store/types';
import { backendCall, createApiCall } from '@reducers/utils';
import { updateFileInBlobStorage } from '@v2/components/imageHandling/helpers';

interface UpdateFileInBlobStoragePayload {
  contentHash: string;
  fileName: string;
  file: Blob;
  textContent: string;
}

export const updateExistingFileInBlobStorage = createAsyncThunk<void, UpdateFileInBlobStoragePayload, { dispatch: AppDispatch }>(
  'imageHandlingV2/updateExistingFileInBlobStorage',
  async ({ contentHash, file, fileName, textContent }, { dispatch }) => {
    const response = await dispatch(
      backendCall(
        createApiCall((api) => api.imageHandling.requestForDocumentUploadV2, {
          params: {
            $type: 'existing',
            contentHash: contentHash,
            fileName: fileName,
          },
        })
      )
    );

    const blobBaseUrl = response.blobAccessInfo.blobUrl;
    const sasToken = response.blobAccessInfo.sasToken;

    await updateFileInBlobStorage({ blobBaseUrl, sasToken, file, content: textContent });
  }
);
